import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import ClosingDisclosureReviewPage from "@/pages/tools/ClosingDisclosureReview";

export const Route = createFileRoute("/tools/closing-disclosure-review")({
  head: () => seoHead("/tools/closing-disclosure-review"),
  component: ClosingDisclosureReviewPage,
});
